import React from 'react';
import {Form} from 'react-final-form';
import arrayMutators from 'final-form-arrays';

import MembersFiltersSearch from "./Members.Filters.Search";
import MembersFiltersList from './Members.Filters.List';
import MembersFiltersView from "./Members.Filters.View";
import Styled from './styled/StyledMember.Filters';

const MembersFilters = ({filters, setFilters}) => {
  const onSubmit = (values) => {
    setFilters(values);
  };

  return (
    <div>
      <Styled.Filters>
        <Form
          onSubmit={onSubmit}
          initialValues={filters}
          mutators={{
            ...arrayMutators
          }}
          render={({handleSubmit}) => (
            <form onSubmit={handleSubmit}>
              <MembersFiltersList
                setFilters={setFilters}
                filters={filters}
              />
              <MembersFiltersView
                setFilters={setFilters}
              />
            </form>
          )}
        />
      </Styled.Filters>
    </div>
  );
};

export default MembersFilters;